import { render, staticRenderFns } from "./PlayerIgnoreList.vue?vue&type=template&id=313e898a&scoped=true&"
import script from "./PlayerIgnoreList.js?vue&type=script&lang=js&"
export * from "./PlayerIgnoreList.js?vue&type=script&lang=js&"
import style0 from "./PlayerIgnoreList.scss?vue&type=style&index=0&id=313e898a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313e898a",
  null
  
)

export default component.exports